<template>
  <el-container class="carSearch">
    <!--  车辆检索-->
    <el-card class="left-card">
      <div class="tree-card-top">
        <el-form ref="formRef" :model="form" size="small" label-position="left">
          <el-form-item label="车辆角度" prop="">
            <img
              v-for="item in imageUrl"
              :key="item.value"
              :src="item.key || imgMoren"
              @click="isActiveImg(item.value)"
              :class="{ treeCardImg: item.value == form.vehicleAttitude }"
            />
          </el-form-item>
          <el-form-item label="车牌状态" style="width: 90%" prop="hasPlate">
            <h-selectcode
              type="plate_no_status"
              v-model="form.hasPlate"
              bx="bx"
              placeholder="请选择"
            ></h-selectcode>
          </el-form-item>
          <el-form-item label="车牌号码">
            <div class="carNum">
              <HCarPlateNoSelect
                v-model:plateColor="form.plateColor"
                v-model:plateNo="form.plateNo"
                label=""
                ref="plateNoRef"
              />
            </div>
          </el-form-item>
          <!-- <el-form-item label="查询方式">
            <el-radio-group v-model="form.cxfs" prop="cxfs">
              <el-radio :label="1">监控设备</el-radio>
              <el-radio :label="2">离线视频</el-radio>
            </el-radio-group>
          </el-form-item> -->
          <el-form-item label="查询范围" class="btnBackground">
            <el-button style="width: 90%" @click="searchRange">{{
              form.deviceIds.length > 0
                ? `已添加${form.deviceIds.length}台设备`
                : "不限"
            }}</el-button>
          </el-form-item>
          <el-form-item label="过车时间">
            <el-select
              v-model="carTimeListstatus"
              placeholder=""
              style="width: 90%"
              clearable
            >
              <el-option
                v-for="(item, index) in carTimeList"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开始时间" v-show="carTimeListstatus == 5">
            <el-date-picker
              v-model="form.beginTime"
              type="datetime"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间" v-show="carTimeListstatus == 5">
            <el-date-picker
              v-model="form.endTime"
              type="datetime"
            ></el-date-picker>
          </el-form-item>
          <el-collapse v-model="activeCarFeater" style="width: 90%">
            <el-collapse-item title="车辆特征" name="1">
              <div>
                <el-form
                  ref="moreFormRef"
                  :model="moreForm"
                  label-width="90px"
                  size="small"
                  label-position="left"
                  class="carFeatuer"
                >
                  <el-form-item label="主驾驶打电话" prop="calling">
                    <h-selectcode
                      type="calling"
                      v-model="moreForm.calling"
                      placeholder="请选择"
                      bx="bx"
                    ></h-selectcode>
                  </el-form-item>
                  <el-form-item label="主驾驶安全带" prop="safetyBelt">
                    <h-selectcode
                      type="calling"
                      v-model="moreForm.safetyBelt"
                      placeholder="请选择"
                      bx="bx"
                    ></h-selectcode>
                  </el-form-item>
                  <el-form-item label="遮阳板状态" prop="sunvisor">
                    <h-selectcode
                      type="calling"
                      v-model="moreForm.sunvisor"
                      placeholder="请选择"
                      bx="bx"
                    ></h-selectcode>
                  </el-form-item>

                  <el-form-item label="是否有挂饰" prop="ornament">
                    <h-selectcode
                      type="calling"
                      v-model="moreForm.ornament"
                      placeholder="请选择"
                      bx="bx"
                    ></h-selectcode>
                  </el-form-item>
                  <el-form-item label="是否有纸巾盒" prop="tissue">
                    <h-selectcode
                      type="calling"
                      v-model="moreForm.tissue"
                      placeholder="请选择"
                      bx="bx"
                    ></h-selectcode>
                  </el-form-item>
                  <el-form-item label="是否年检标识" prop="inspectionMark">
                    <h-selectcode
                      type="calling"
                      v-model="moreForm.inspectionMark"
                      placeholder="请选择"
                      bx="bx"
                    ></h-selectcode>
                  </el-form-item>
                  <el-form-item label="是否是渣土车" prop="muckCar">
                    <h-selectcode
                      type="calling"
                      v-model="moreForm.muckCar"
                      placeholder="请选择"
                      bx="bx"
                    ></h-selectcode>
                  </el-form-item>
                  <el-form-item label="是否危化品车" prop="hazardousTanker">
                    <h-selectcode
                      type="calling"
                      v-model="moreForm.hazardousTanker"
                      placeholder="请选择"
                      bx="bx"
                    ></h-selectcode>
                  </el-form-item>
                  <el-form-item label="是否有天窗" prop="sunroof">
                    <h-selectcode
                      type="calling"
                      v-model="moreForm.sunroof"
                      placeholder="请选择"
                      bx="bx"
                    ></h-selectcode>
                  </el-form-item>
                  <el-form-item label="是否有香水" prop="perfumeBottle">
                    <h-selectcode
                      type="calling"
                      v-model="moreForm.perfumeBottle"
                      placeholder="请选择"
                      bx="bx"
                    ></h-selectcode>
                  </el-form-item>
                  <el-form-item label="是否有备胎" prop="spareWheel">
                    <h-selectcode
                      type="calling"
                      v-model="moreForm.spareWheel"
                      placeholder="请选择"
                      bx="bx"
                    ></h-selectcode>
                  </el-form-item>
                  <el-form-item label="是否有行李架" prop="luggageRack">
                    <h-selectcode
                      type="calling"
                      v-model="moreForm.luggageRack"
                      placeholder="请选择"
                      bx="bx"
                    ></h-selectcode>
                  </el-form-item>
                  <el-form-item label="副驾驶遮阳板" prop="coSunvisor">
                    <h-selectcode
                      type="calling"
                      v-model="moreForm.coSunvisor"
                      placeholder="请选择"
                      bx="bx"
                    ></h-selectcode>
                  </el-form-item>
                </el-form>
              </div>
            </el-collapse-item>
          </el-collapse>
          <el-form-item label="车身颜色" prop="vehicleColor" style="width: 90%">
            <h-selectcode
              type="vehicle_color_six"
              v-model="form.vehicleColor"
              placeholder="请选择"
              bx="bx"
            ></h-selectcode>
          </el-form-item>
          <el-form-item label="车牌类型" prop="plateClass" style="width: 90%">
            <h-selectcode
              type="carType"
              v-model="form.plateClass"
              placeholder="请选择"
              bx="bx"
            ></h-selectcode>
          </el-form-item>
          <el-form-item label="车辆类型" prop="vehicleClass" style="width: 90%">
            <h-selectcode
              type="carType"
              v-model="form.vehicleClass"
              placeholder="请选择"
              bx="bx"
            ></h-selectcode>
          </el-form-item>
          <el-form-item label="行驶方向" prop="direction" style="width: 90%">
            <h-selectcode
              type="driver_direct"
              v-model="form.direction"
              placeholder="请选择"
              bx="bx"
            ></h-selectcode>
          </el-form-item>
          <el-form-item label="车道编号" prop="laneNo" style="width: 90%">
            <h-selectcode
              type="lane"
              v-model="form.laneNo"
              placeholder="请选择"
              bx="bx"
            ></h-selectcode>
          </el-form-item>
          <el-form-item
            label="车辆品牌"
            prop="vehicleBrands"
            style="width: 90%"
          >
            <h-selectcode
              type="vehicle_brand"
              v-model="form.vehicleBrands"
              placeholder=""
              multiple="true"
            ></h-selectcode>
          </el-form-item>
        </el-form>
      </div>
      <div class="tree-card-bottom">
        <el-button type="primary" @click="refreshTable">查询</el-button>
        <el-button @click="resetForm(formRef)">重置表单</el-button>
      </div>
    </el-card>
    <el-card class="tabs-card">
      <div class="tabs-card-img" v-if="totalCount != 0">
        <template v-for="(item, index) in tableDate" :key="index">
          <car-detail
            :itemInfo="item"
            v-model:plateColor="plateColorList"
            @click="clickCarDetial(item)"
          ></car-detail>
        </template>
      </div>

      <el-empty class="empty" v-else></el-empty>
      <el-pagination
        v-model:page-size="form.pageSize"
        :page-sizes="[20, 50, 100, 200]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </el-card>
    <carDetailDialog
      v-if="carDetailVisible"
      v-model:visible="carDetailVisible"
      :itemInfo="carDetailItem"
      :tableParams="form"
    ></carDetailDialog>
    <bayonet-transfer-application
      v-show="transferVisible"
      v-model:visible="transferVisible"
      @transferApplicationList="getTransferList"
    ></bayonet-transfer-application>
    <!-- <transfer-application
      @transferApplicationList="getTransferList"
      v-model:visible="transferVisible"
    ></transfer-application> -->
  </el-container>
</template>
<script>
import {
  defineComponent,
  nextTick,
  reactive,
  toRefs,
  ref,
  watch,
  watchEffect,
} from "vue";
import bayonetTransferApplication from "@/views/publicSecurityResearch/keyKehiclesV2/components/bayonetTransferApplication";
import searchRangeDialog from "./components/searchRangeDialog.vue";
import { propRetrievalV2 } from "@/api/smartApplication/smartApplicationApi.js";
import { getDict } from "@/api/constant";
import moment from "moment";
export default defineComponent({
  name: "carSearch",
  components: { bayonetTransferApplication },
  props: {},
  setup(props) {
    const state = reactive({
      imgMoren: require("@/assets/images/cheshen.png"),

      treeCard: {
        height: "100%",
        display: "flex",
        flexDirection: "column",
      },
      carDetailVisible: false,
      transferVisible: false,
      showCarFeater: false,
      activeCarFeater: "0",
      form: {
        beginTime: null,
        endTime: null,
        hasPlate: "", // 车牌状态
        plateColor: "", // 车牌颜色
        plateNo: "", // 车牌号
        // cxfs: 1, //查询方式
        deviceIds: [], // 设备列表
        vehicleColor: "", // 车身颜色
        vehicleClass: "", // 车辆类型
        plateClass: "", // 车牌类型
        direction: "", // 行驶方向
        laneNo: "", // 车道编号
        pageSize: 20, // 每页数
        pageNum: "1", // 每页数
        vehicleAttitude: "", // 拍摄角度
        vehicleBrands: [], // 车辆品牌
      },
      moreForm: {
        calling: "", // 是否打电话
        safetyBelt: "", // 是否安全带
        sunvisor: "", // 驾驶遮阳板
        ornament: "", // 是否有挂件
        tissue: "", // 是否纸盒
        inspectionMark: "", // 是否年检
        muckCar: "", // 是否渣土车
        hazardousTanker: "", // 是否危化品
        coSunvisor: "", // 副驾驶遮阳板
        sunroof: "", // 天窗
        perfumeBottle: "", // 香水
        spareWheel: "", // 备胎
        luggageRack: "", // 行李架
      },
      carTimeListstatus: 1,

      plateColorList: ["5", "6"],
      carTimeList: [
        { label: "近1天", value: 1 },
        { label: "近3天", value: 3 },
        { label: "近7天", value: 7 },
        { label: "近30天", value: 30 },
        { label: "自定义", value: 5 },
      ],

      imageUrl: [
        {
          key: require("@/assets/images/chetou.png"),
          value: "0",
        },
        {
          key: require("@/assets/images/cheshen.png"),
          value: "1",
        },
        {
          key: require("@/assets/images/chewei.png"),
          value: "2",
        },
      ],

      tableDate: [
        // {
        //   deviceId: "50015400051191000661",
        //   deviceName: "南山东路与德阳街德阳中学入口",
        //   direction: null,
        //   directionDesc: null,
        //   laneNo: null,
        //   laneNoDesc: null,
        //   latitude: "31.170607",
        //   leftTopX: "840.0",
        //   leftTopY: "426.0",
        //   longitude: "108.416296",
        //   motorVehicleId: "500154000511910006610220220319000000035170203517",
        //   passTime: "1647619200000",
        //   passTimeDesc: "2022-03-19 00:00:00",
        //   plateCharReliability: null,
        //   plateClass: "99",
        //   plateClassDesc: "其他",
        //   plateColor: "99",
        //   plateColorDesc: "null",
        //   plateColorName: "其他",
        //   plateNo: "",
        //   rightBtmX: "1218.0",
        //   rightBtmY: "736.0",
        //   stateInfomation: "无",
        //   storageUrlCloseShot:
        //     "http://50.136.50.140:9003/?scenevehicles/dn@1_4/12/30-c6d8e50-15063",
        //   storageUrlCloseShotFid:
        //     "02/3/scenevehicles/dn@1_4/12/30-c6d8e50-15063",
        //   storageUrlPlate: null,
        //   storageUrlPlateFid: null,
        //   tollgateId: "50015400051211000579",
        //   vehicleBrand: "1",
        //   vehicleBrandDesc: "大众",
        //   vehicleClass: "H10002",
        //   vehicleClassDesc: "越野车",
        //   vehicleClassParent: "4",
        //   vehicleClassParentDesc: "越野车",
        //   vehicleColor: "2",
        //   vehicleColorDepth: null,
        //   vehicleColorDesc: "白",
        //   vehicleLog:
        //     "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEAYABgAAD/2wBDAAQCAwMDAgQDAwMEBAQEBQkGBQUFBQsICAYJDQsNDQ0LDAwOEBQRDg8TDwwMEhgSExUWFxcXDhEZGxkWGhQWFxb",
        // },
      ],
      totalCount: 0,
      carDetailItem: null,
    });
    const refData = toRefs(state);
    const moreFormRef = ref();
    const formRef = ref();
    watchEffect(() => {
      state.form.beginTime = moment(new Date().getTime() - 3600 * 1000 * state.carTimeListstatus * 24).format("YYYY-MM-DD 00:00:00");
      state.form.endTime = moment(new Date()).format("YYYY-MM-DD 23:59:59");
    });
    //打开卡口框
    const searchRange = () => {
      state.transferVisible = true;
    };
    //打开车辆详情弹窗
    const clickCarDetial = (item) => {
      state.carDetailVisible = true;
      state.carDetailItem = item;
    };
    //获取卡口数据
    const getTransferList = (list) => {
      state.form.deviceIds = [];
      list.forEach((element) => {
        state.form.deviceIds.push(element.deviceId);
      });
    };
    //车辆特征
    const displayCarFeature = () => {
      state.showCarFeater = !state.showCarFeater;
    };
    //拍摄角度
    const isActiveImg = (val) => {
      state.form.vehicleAttitude = val;
    };
    //接口请求
    const handleAnlaysis = async (params) => {
      const resCarColor = await getDict("car_card_color");
      state.plateColorList = resCarColor.dict;
      const res = await propRetrievalV2(params, {
        loading: true,
        loadingDom: ".tabs-card",
      });
      if (res) {
        res.page.list.forEach((item) => {
          item.passTime = moment(parseInt(item.snapTime)).format(
            "YYYY-MM-DD HH:mm:ss"
          );
        });
        state.tableDate = res.page.list;
        state.totalCount = res.page.totalCount;
      }
    };

    // // 点击查询按钮
    const refreshTable = () => {
      state.form.beginTime = moment(state.form.beginTime).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      state.form.endTime = moment(state.form.endTime).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      const param = {
        ...state.form,
        ...state.moreForm,
      };
      for (let key in param) {
        if (param[key] === "") {
          Reflect.deleteProperty(param, key);
        }
      }
      handleAnlaysis(param);
      // tableRef.value && tableRef.value.refresh();
    };
    //数据切换页码
    const handleCurrentChange = (val) => {
      state.form.pageNum = val;
      refreshTable();
    };
    //数据切换页码
    const handleSizeChange = (val) => {
      state.form.pageSize = val;
      refreshTable();
    };
    // 重置表单
    const resetForm = () => {
      if (!moreFormRef.value || !formRef.value) return;
      state.form.deviceIds = [];
      state.form.isActiveImgValue = "";
      state.form.plateNo = "";
      state.form.plateColor = "";
      state.carTimeListstatus = 1;
      moreFormRef.value.resetFields();
      formRef.value.resetFields();
    };
    return {
      ...refData,
      formRef,
      moreFormRef,
      searchRange,
      clickCarDetial,
      getTransferList,
      displayCarFeature,
      isActiveImg,
      refreshTable,
      handleCurrentChange,
      handleSizeChange,
      resetForm,
    };
  },
});
</script>
<style lang="scss" scoped>
.carSearch {
  .left-card {
    height: 100%;
    width: 300px;
    .tree-card-top {
      width: 100%;
      height: 90%;
      overflow: auto;
      .el-form-item {
        flex-direction: column;
        margin-bottom: calc(var(--font-size) + 0px) !important;

        img {
          width: 80px;
          height: 70px;
          padding: 8px 8px;
          // background-image: url("~@/assets/images/chenshen.png");
        }

        .treeCardImg {
          border: 1px solid #333;
        }
      }
      .carNum {
        @include flex-row-c-c;
        /deep/.el-select {
          width: 60px;
        }
      }
      .el-collapse:hover {
        background-color: cadetblue;
      }
      .carFeatuer {
        @include flex-row-sb-c;
        flex-wrap: wrap;
        .el-form-item {
          width: 45%;
        }
      }
    }
    .tree-card-bottom {
      width: 100%;
      margin-top: 24px;
      @include flex-row-c-c;
    }
  }
  .tabs-card {
    flex: 1;
    margin-left: 10px;
    .tabs-card-img {
      height: 95%;
      display: grid;
      grid-template-columns: repeat(auto-fill, 340px);
      grid-gap: 11px 24px;
      justify-content: space-around;
      overflow: auto;
    }
    .el-pagination {
      margin-top: 16px;
    }
  }
  :deep(.el-input__inner) {
    height: 30px;
  }
}
</style>
